import {AfterViewInit, Component, Input, OnChanges, SimpleChanges, ViewChild} from '@angular/core';
import {MatPaginator, MatPaginatorModule} from '@angular/material/paginator';
import {MatSort, MatSortModule} from '@angular/material/sort';
import {MatTableDataSource, MatTableModule} from '@angular/material/table';
import {RestorationPoint} from '../../../../../shared/classes/restoration-point';
import {DatePipe, DecimalPipe} from '@angular/common';
import {MatIconModule} from '@angular/material/icon';

@Component({
    selector: 'tgrid-restoration-curve-table',
    imports: [
        DatePipe,
        MatPaginatorModule,
        MatSortModule,
        MatTableModule,
        MatIconModule,
        DecimalPipe,
    ],
    templateUrl: './restoration-curve-table.component.html',
    styleUrl: './restoration-curve-table.component.scss',
})
export class RestorationCurveTableComponent implements AfterViewInit, OnChanges {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;

  @Input() curves?: RestorationPoint[] ;

  public readonly columns: string[] = ['run_start_time', 'total_customers', 'impacted_customers', 'highThreshold',
    'lowThreshold',  'morethanLowThreshold', 'morethanHighThreshold' ];
  public dataSource: MatTableDataSource<RestorationPoint> = new MatTableDataSource<RestorationPoint>([]);

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
    this.dataSource.data = this.curves || [];
  }

  ngOnChanges(changes: SimpleChanges) {
    this.dataSource.data = changes['curves'].currentValue;
  }


}
